import type { StyleSpecification } from 'maplibre-gl';

/** Esri World Imagery raster basemap — no API key required. */
export const MAPPER_BASEMAP_STYLE: StyleSpecification = {
  version: 8,
  // MapLibre requires glyphs for any symbol layer with text-field (Mapbox token styles bundled these).
  glyphs: 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf',
  sources: {
    'esri-world-imagery': {
      type: 'raster',
      tiles: [
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      ],
      tileSize: 256,
      attribution: 'Esri, Maxar, Earthstar Geographics',
    },
  },
  layers: [
    {
      id: 'esri-world-imagery',
      type: 'raster',
      source: 'esri-world-imagery',
      minzoom: 0,
      maxzoom: 22,
    },
  ],
};
